<template>
    <div class="login-container" ref="login" @keyup.enter.native="handleLogin">
        <loginHeader></loginHeader>
        <div class="login-container-bottom">
            <div class="login-weaper animated bounceInDown">
                <div class="login-border">
                    <div class="w100">
                        <div class="login-title">
                            <div>{{activeName==='user'?'密码登录':'扫码登录'}}<topLang></topLang></div>
                            <el-tooltip class="qr-wrapper" visible="true" effect="light" :content="activeName==='user'?'扫码登录':'密码登录'" placement="left">
                                <div class="qr-code" @click="activeName==='user'?activeName='code':activeName='user'">
                                    <img :src="`/img/bg/${activeName==='user'?'qr-code':'login-code'}.png`" class="img">
                                </div>
                            </el-tooltip>
                        </div>
                        <div class="login-main">
                            <userLogin v-if="activeName==='user'"></userLogin>
                            <codeLogin v-else-if="activeName==='code'"></codeLogin>
                            <thirdLogin v-else-if="activeName==='third'"></thirdLogin>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cfooter></cfooter>
    </div>
</template>
<script>
import userLogin from "./userlogin";
import codeLogin from "./codelogin";
import loginHeader from './components/loginheader'
import thirdLogin from "./thirdlogin";
import cfooter from "../index/footer"
import { mapGetters } from "vuex";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
import topLang from "@/page/index/top/top-lang";
import topColor from "@/page/index/top/top-color";
import { getQueryString, getTopUrl } from "@/util/util";

export default {
    name: "login",
    components: {
        userLogin,
        codeLogin,
        thirdLogin,
        topLang,
        topColor,
        loginHeader,
        cfooter
    },
    data() {
        return {
            time: "",
            activeName: "user",
            socialForm: {
                tenantId: "000000",
                source: "",
                code: "",
                state: "",
            }
        };
    },
    watch: {
        $route() {
            this.handleLogin();
        }
    },
    created() {
        this.handleLogin();
        this.getTime();
    },
    mounted() {},
    computed: {
        ...mapGetters(["website", "tagWel"])
    },
    props: [],
    methods: {
        getTime() {
            setInterval(() => {
                this.time = dateFormat(new Date());
            }, 1000);
        },
        handleLogin() {
            const topUrl = getTopUrl();
            const redirectUrl = "/oauth/redirect/";
            this.socialForm.source = getQueryString("source");
            this.socialForm.code = getQueryString("code");
            this.socialForm.state = getQueryString("state");
            if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
                let source = topUrl.split("?")[0];
                source = source.split(redirectUrl)[1];
                this.socialForm.source = source;
            }
            if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
                const loading = this.$loading({
                    lock: true,
                    text: '第三方系统登录中,请稍后。。。',
                    spinner: "el-icon-loading"
                });
                this.$store.dispatch("LoginBySocial", this.socialForm).then(() => {
                    window.location.href = topUrl.split(redirectUrl)[0];
                    this.$router.push({ path: this.tagWel.value });
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            }
        }
    }
};

</script>
<style lang="scss">
@import "@/styles/login.scss";

</style>
